import React, { useEffect, useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  Row,
  Col
} from "reactstrap";

import { toast } from "react-toastify";
import { createUserApi, updateUserApi } from "../../api/apiUrlConst";

interface Props {
  isOpen: boolean;
  toggle: () => void;
  user?: any;
  refresh: () => void;
}

const UserFormModal: React.FC<Props> = ({
  isOpen,
  toggle,
  user,
  refresh
}) => {
  const isEdit = !!user;

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    phoneNumber: "",
    gender: "",
    role: "Guest",
    isActive: true
  });

  useEffect(() => {
    if (user) {
      setFormData({
        name: user.name || "",
        email: user.email || "",
        password: "",
        phoneNumber: user.phoneNumber || "",
        gender: user.gender || "",
        role: user.role || "Guest",
        isActive: user.isActive ?? true
      });
    } else {
      setFormData({
        name: "",
        email: "",
        password: "",
        phoneNumber: "",
        gender: "",
        role: "Guest",
        isActive: true
      });
    }
  }, [user, isOpen]);

  const handleChange = (e: any) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async () => {
    try {
      if (isEdit) {
        await updateUserApi(user.userId, {
          name: formData.name,
          phoneNumber: formData.phoneNumber,
          gender: formData.gender,
          role: formData.role,
          isActive: formData.isActive
        });

        toast.success("User updated successfully");
      } else {
        await createUserApi(formData);
        toast.success("User created successfully");
      }

      refresh();
      toggle();
    } catch (error: any) {
      toast.error(error?.response?.data || "Something went wrong");
    }
  };

  return (
   <Modal
  isOpen={isOpen}
  toggle={toggle}
  centered
  contentClassName="border-0 shadow-lg"
>
  {/* Header */}
  <ModalHeader
    toggle={toggle}
    style={{
      background: "linear-gradient(90deg, #374151, #093d92)",
      color: "#fff",
      borderTopLeftRadius: "6px",
      borderTopRightRadius: "6px",
      fontWeight: "600",
    }}
  >
    {isEdit ? "Edit User" : "Create User"}
  </ModalHeader>

  <ModalBody
    style={{
      padding: "30px",
      background: "#f9fafc",
    }}
  >
    <Form className="d-flex flex-column gap-3">

      <Row>
        <Col md={6}>
          <FormGroup>
            <Label className="fw-semibold">Full Name</Label>
            <Input
              name="name"
              value={formData.name}
              onChange={handleChange}
              className="rounded-pill shadow-sm"
              placeholder="Enter full name"
            />
          </FormGroup>
        </Col>

        <Col md={6}>
          <FormGroup>
            <Label className="fw-semibold">Email</Label>
            <Input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              disabled={isEdit}
              className="rounded-pill shadow-sm"
              placeholder="Enter email"
            />
          </FormGroup>
        </Col>
      </Row>

      {!isEdit && (
        <FormGroup>
          <Label className="fw-semibold">Password</Label>
          <Input
            type="password"
            name="password"
            value={formData.password}
            onChange={handleChange}
            className="rounded-pill shadow-sm"
            placeholder="Create password"
          />
        </FormGroup>
      )}

      <Row>
        <Col md={6}>
          <FormGroup>
            <Label className="fw-semibold">Phone Number</Label>
            <Input
              name="phoneNumber"
              value={formData.phoneNumber}
              onChange={handleChange}
              className="rounded-pill shadow-sm"
              placeholder="Enter phone number"
            />
          </FormGroup>
        </Col>

        <Col md={6}>
          <FormGroup>
            <Label className="fw-semibold">Gender</Label>
            <Input
              type="select"
              name="gender"
              value={formData.gender}
              onChange={handleChange}
              className="rounded-pill shadow-sm"
            >
              <option value="">Select Gender</option>
              <option>Male</option>
              <option>Female</option>
              <option>Other</option>
            </Input>
          </FormGroup>
        </Col>
      </Row>

      <FormGroup>
        <Label className="fw-semibold">Role</Label>
        <Input
          type="select"
          name="role"
          value={formData.role}
          onChange={handleChange}
          className="rounded-pill shadow-sm"
        >
          <option value="">Select Role</option>
          <option>Admin</option>
          <option>Coordinator</option>
          <option>Guest</option>
        </Input>
      </FormGroup>

      {isEdit && (
        <div className="d-flex align-items-center justify-content-between mt-2">
          <span className="fw-semibold">Active Status</span>
          <div className="form-check form-switch">
            <input
              className="form-check-input"
              type="checkbox"
              checked={formData.isActive}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  isActive: e.target.checked,
                })
              }
            />
          </div>
        </div>
      )}

    </Form>
  </ModalBody>

  {/* Footer */}
  <ModalFooter
    style={{
      borderTop: "none",
      padding: "20px 30px",
      background: "#f9fafc",
      borderBottomLeftRadius: "15px",
      borderBottomRightRadius: "15px",
    }}
  >
    <Button
      color="secondary"
      outline
      onClick={toggle}
      style={{
        borderRadius: "20px",
        padding: "6px 20px",
      }}
    >
      Cancel
    </Button>

    <Button
      onClick={handleSubmit}
      style={{
        background: "linear-gradient(90deg, #667eea, #764ba2)",
        border: "none",
        borderRadius: "20px",
        padding: "6px 20px",
        fontWeight: "600",
      }}
    >
      {isEdit ? "Update User" : "Create User"}
    </Button>
  </ModalFooter>
</Modal>
  );
};

export default UserFormModal;